import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-system/dict/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getParentList = (current, size, params) => {
    return request({
        url: '/api/blade-system/dict/parent-list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getChildList = (current, size, parentId, params) => {
    return request({
        url: '/api/blade-system/dict/child-list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
            parentId: parentId,
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-system/dict/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-system/dict/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-system/dict/submit',
        method: 'post',
        data: row
    })
}


export const getDict = (id) => {
    return request({
        url: '/api/blade-system/dict/detail',
        method: 'get',
        params: {
            id,
        }
    })
}
export const getDictTree = () => {
    return request({
        url: '/api/blade-system/dict/tree?code=DICT',
        method: 'get'
    })
}

export const getDictionary = (params) => {
    return request({
        url: '/api/blade-system/dict/dictionary',
        method: 'get',
        params,
    })
}

export const getBasicConfig = (params) => request({
    url: '/api/blade-system/param/basic-config',
    method: 'get',
    params,
    authorization: true
});

export const getQueryList = (data) => request({
    url: '/api/blade-loanProductManagement/loanProductManagement/queryList',
    method: 'post',
    data,
});

// 产品联级搜索
export const getProductTypeList = () => request({
    url: '/api/blade-loanProductManagement/loanProductManagement/getCascade',
    method: 'get',
})